import React, { useCallback } from 'react';
import useTabsBackButtonState from './useTabBackButtonState';

const withTabBackButton = (WrappedComponent) => {
  const BackButtonComponent = (props) => {
    const [handleOnTabBackPress, setHandleOnTabBackPress] = useTabsBackButtonState();
    const _handleOnTabBackPress = useCallback(() => {
      if (handleOnTabBackPress && setHandleOnTabBackPress) {
        handleOnTabBackPress();
        setHandleOnTabBackPress(null);
      }
    }, [handleOnTabBackPress, setHandleOnTabBackPress]);

    return (
      <WrappedComponent id='tab-backbuttonhandler-component'
        {...props}
        handleOnTabBackPress={handleOnTabBackPress ? _handleOnTabBackPress : null}
        setHandleOnTabBackPress={setHandleOnTabBackPress}
      />
    );
  };
  return BackButtonComponent;
};

export default withTabBackButton;
